import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import GlobalContext from "../../context/GlobalContext";
import CategoryBtn from "../common/CategoryBtn";
import TagsScroll from "./../styled/TagsScroll";
import bgImg from "../../assets/micasabackground.jpg";

const CategoriesScroll = () => {
  const context = useContext(GlobalContext);
  const { type, category, restaurantId } = useParams();
  console.log("CategoriesScroll", context.configuration.table);
  const getBackgroundStyle = () => {
    let style = { position: "fixed", top: 59, zIndex: 20, width: "100%", filter: context.blur }

    return style;
  }
  const renderCategories = () => {
    return (
      <div
        style={getBackgroundStyle()}
        className="slide-in-right"
      >
        <TagsScroll style={{ overflowX: "scroll" ,overflowY: "hidden", paddingBottom : "2%", backgroundColor: context.configuration.uiConfig.backgroundColor }}>
          {context.menu[type].categories.map((c) => (
            <CategoryBtn
              title={c.name}
              to={"/" + restaurantId + "/categories/" + type + "/" + c.categoryId + context?.configuration?.table}
              selected={category === c.categoryId}
              key={c.categoryId}
            />
          ))}
        </TagsScroll>
      </div>
    );
  };

  return renderCategories();
};

export default CategoriesScroll;
